import React from 'react';
import { Link } from 'react-router-dom';
import { FooterCTA } from '../components/FooterCTA';
export function Magazin() {
  const products = [{
    title: 'ProVi System',
    description: 'Sistem complet de conducere antreprenorială implementat în 12 luni.',
    path: '/provisystem',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800',
    tag: 'Implementare 12 Luni'
  }, {
    title: 'Training Personalizat',
    description: 'Aliniază-ți echipa și crește productivitatea cu un training dedicat.',
    path: '/trainingpersonalizat',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=800',
    tag: 'Pentru Echipe'
  }, {
    title: 'Ședință Trimestrială',
    description: 'Planificare strategică pentru următorul trimestru alături de echipa ta.',
    path: '/sedintatrimestriala',
    image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&q=80&w=800',
    tag: 'Planificare'
  }, {
    title: 'ProVi Sprint',
    description: 'Implementare accelerată în 12 săptămâni pentru rezultate rapide.',
    path: '/provisprint',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800',
    tag: 'Program 12 Săptămâni'
  }, {
    title: 'Workshop',
    description: 'Ieși din haosul operațional în 90 de zile. Sesiune intensivă de 2-3 ore.',
    path: '/workshop',
    image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&q=80&w=800',
    tag: 'Sesiune Intensivă'
  }, {
    title: 'ProVi Toolkit',
    description: 'Instrumentele simple și clare cu care pui ordine în afacere singur.',
    path: '/provitoolkit',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=800',
    tag: 'Produs Digital'
  }];
  return <div className="bg-[#09111F] min-h-screen pt-32 pb-0" data-id="element-513">
      {/* Header Section */}
      <section className="px-5 md:px-12 max-w-[1200px] mx-auto text-center mb-16" data-id="element-514">
        <div className="inline-flex items-center gap-2 bg-[rgba(29,78,216,0.15)] border border-[rgba(29,78,216,0.3)] px-4 py-2 rounded-full mb-8" data-id="element-515">
          <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.15em] uppercase text-[#3B82F6]" data-id="element-516">
            SERVICII & OFERTE
          </span>
        </div>
        <h1 className="font-['Montserrat'] text-[clamp(32px,5vw,56px)] font-extrabold text-white mb-6 leading-[1.1] tracking-tight" data-id="element-517">
          Alege programul potrivit
          <br data-id="element-518" />
          pentru afacerea ta
        </h1>
        <p className="font-['Inter'] text-[19px] text-[rgba(255,255,255,0.7)] max-w-[700px] mx-auto leading-[1.6]" data-id="element-519">
          Fiecare ofertă este concepută pentru un alt punct de plecare. Dacă nu
          știi de unde să începi, programează mai întâi sesiunea gratuită de
          evaluare.
        </p>
      </section>

      {/* Grid Section */}
      <section className="px-5 md:px-12 max-w-[1200px] mx-auto mb-24" data-id="element-520">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-521">
          {products.map((product, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg flex flex-col transition-transform duration-300 hover:-translate-y-2 group" data-id="element-522">
              {/* Image (clickable + zoom on hover) */}
              <Link to={product.path} className="relative h-48 overflow-hidden block" data-id="element-523">
                <img src={product.image} alt={product.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-524" />
                <div className="absolute top-4 left-4 bg-[#09111F]/80 backdrop-blur-sm text-white font-['Montserrat'] text-[11px] font-bold tracking-wider uppercase px-3 py-1.5 rounded-full" data-id="element-525">
                  {product.tag}
                </div>
              </Link>
              <div className="p-8 flex flex-col flex-grow" data-id="element-526">
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-3" data-id="element-527">
                  {product.title}
                </h3>
                <p className="font-['Inter'] text-[16px] text-[#4B5563] mb-8 flex-grow leading-[1.6]" data-id="element-528">
                  {product.description}
                </p>
                <Link to={product.path} className="inline-flex justify-center items-center w-full font-['Montserrat'] text-[14px] font-bold bg-[#1D4ED8] text-white px-6 py-3.5 rounded-xl hover:bg-[#2563EB] transition-colors" data-id="element-529">
                  Vezi detalii →
                </Link>
              </div>
            </div>)}
        </div>
      </section>

      <FooterCTA title="Nu știi ce ți se potrivește?" subtitle="Programează o sesiune gratuită de evaluare și te ajut să găsești drumul potrivit pentru afacerea ta." buttonText="Programează Sesiunea Gratuită" data-id="element-530" />
    </div>;
}